import _BaseAPIService from "./_BaseAPIService";

  const apiService = _BaseAPIService.instance;
const UniversityService = {
  getList: async () => {
    const response = await apiService.get("/universities");
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/universities/${id}`);
    return response.data;
  },
    getBySlug: async (slug) => {
  const response = await apiService.get(`/universities/slug`, {
    params: { slug }
  });
  return response.data;
}
}

export default UniversityService
